import { FC, useState } from 'react';
import { useSuppliers } from 'store/suppliers';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const SuppliersFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: suppliers, isLoading } = useSuppliers({
    name: search,
    status: 'active',
  });

  return (
    <SelectFilter
      {...props}
      options={suppliers?.items.map((supplier) => ({
        key: supplier.id,
        label: supplier.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
